const unicodeToAsciiMap = new Map<number, string>([
  // https://lhncbc.nlm.nih.gov/LSG/Projects/lvg/current/docs/designDoc/UDF/unicode/DefaultTables/symbolTable.html
  [0x00ab, '"'],
  [0x00ad, '-'],
  [0x00b4, "'"],
  [0x00bb, '"'],
  [0x00f7, '/'],
  [0x01c0, '|'],
  [0x01c3, '!'],
  [0x02b9, "'"],
  [0x02ba, '"'],
  [0x02bc, "'"],
  [0x02c4, '^'],
  [0x02c6, '^'],
  [0x02c8, "'"],
  [0x02cb, '`'],
  [0x02cd, '_'],
  [0x02dc, '~'],
  [0x0300, '`'],
  [0x0301, "'"],
  [0x0302, '^'],
  [0x0303, '~'],
  [0x030b, '"'],
  [0x030e, '"'],
  [0x0331, '_'],
  [0x0332, '_'],
  [0x0338, '/'],
  [0x0589, ':'],
  [0x05c0, '|'],
  [0x05c3, ':'],
  [0x066a, '%'],
  [0x066d, '*'],
  [0x200b, ' '],
  [0x2010, '-'],
  [0x2011, '-'],
  [0x2012, '-'],
  [0x2013, '-'],
  [0x2014, '-'],
  [0x2015, '-'],
  [0x2016, '||'],
  [0x2017, '_'],
  [0x2018, "'"],
  [0x2019, "'"],
  [0x201a, ','],
  [0x201b, "'"],
  [0x201c, '"'],
  [0x201d, '"'],
  [0x00a8, '"'],
  [0x201e, '"'],
  [0x201f, '"'],
  [0x2032, "'"],
  [0x2033, '"'],
  [0x2034, "'''"],
  [0x2035, '`'],
  [0x2036, '"'],
  [0x2037, "'''"],
  [0x2038, '^'],
  [0x2039, '<'],
  [0x203a, '>'],
  [0x203d, '?'],
  [0x2044, '/'],
  [0x204e, '*'],
  [0x2052, '%'],
  [0x2053, '~'],
  [0x2060, ''],
  [0x20e5, '\\'],
  [0x2212, '-'],
  [0x2215, '/'],
  [0x2216, '\\'],
  [0x2217, '*'],
  [0x2223, '|'],
  [0x2236, ':'],
  [0x223c, '~'],
  [0x2264, '<='],
  [0x2265, '>='],
  [0x2266, '<='],
  [0x2267, '>='],
  [0x2303, '^'],
  [0x2329, '<'],
  [0x232a, '>'],
  [0x266f, '#'],
  [0x2731, '*'],
  [0x2758, '|'],
  [0x2762, '!'],
  [0x27e6, '['],
  [0x27e8, '<'],
  [0x27e9, '>'],
  [0x2983, '{'],
  [0x2984, '}'],
  [0x3003, '"'],
  [0x3008, '<'],
  [0x3009, '>'],
  [0x301b, ']'],
  [0x301c, '~'],
  [0x301d, '"'],
  [0x301e, '"'],
  [0xfeff, ''],
]);

/** Given a string convert all known unicode characters to ascii, retain unicode characters if we must */
export const convertUnicodeToAscii = (value: string | null) => {
  if (!value) {
    return '';
  }

  let result = '';
  for (const char of value) {
    const code = char.charCodeAt(0);

    // check if code is an ascii character
    if (code >= 0x20 && code <= 0x7e) {
      result += char;
      continue;
    }

    if (unicodeToAsciiMap.has(code)) {
      result += unicodeToAsciiMap.get(code);
    } else {
      // leave the character as is - unable to convert
      result += char;
    }
  }

  return result;
};

/** Given a string return an error if a non ascii character is found */
export const isInvalidAscii = (value: string | null) => {
  if (!value) {
    return null;
  }

  for (const char of value) {
    const code = char.charCodeAt(0);

    // allow return key to be pressed
    if (code === 10 || code === 14) {
      continue;
    }

    // check if code is an ascii character
    if (code < 0x20 || code > 0x7e) {
      return 'Special Character "' + char + '" is not supported';
    }
  }

  return null;
};
